"use client";

import { openCookieSettings } from "@/lib/cookie-consent";

export function CookieSettingsButton() {
  return (
    <button
      type="button"
      onClick={openCookieSettings}
      className="text-sm text-slate-400 transition hover:text-white"
    >
      Cookie-Einstellungen
    </button>
  );
}
